<!-- Navigation -->
<div class="navigation">
  <!-- <mat-form-field>
    <input matInput type="search" autocomplete="off" placeholder="Zoeken">
  </mat-form-field> -->
  <mat-form-field>
    <mat-label></mat-label>
    <mat-select [(ngModel)]="currentView" (selectionChange)="setView(currentView)">
      <mat-option *ngFor="let view of views" [value]="view">
        {{ view.label | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<!-- Muted TinyMCE toolbar -->
<img src="./../../../../assets/tinymce/tinymce-toolbar.png">

<!-- TinyMCE toolbar container -->
<div id="toolbar-container-tinymce"></div>

<!-- Preload TinyME to make sure it's always ready on click in document view -->
<div class="tinymce-init">
  <editor [init]="config" [inline]="true" plugins="textcolor table"></editor>
</div>

<!-- Add modules -->
<!-- To do: Add submodules and elements -->
<span class="options">

  <!-- <mat-form-field>
    <mat-label></mat-label>
    <mat-select [(ngModel)]="currentEditInline" (selectionChange)="setEditMode(currentEditInline)">
      <mat-option [value]="true">
        Tekst bewerken in document
      </mat-option>
      <mat-option [value]="false">
        Tekst bewerken in pop-up
      </mat-option>
    </mat-select>
  </mat-form-field> -->

  <sg2-project-info-button-add></sg2-project-info-button-add>
</span>
